export default __webpack_public_path__ + "static/media/partner-l2y.757dd48c.jpg";